module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-top",
    class: {
      active: this.gridActive
    },
    attrs: {
      "id": "grid-wrapper"
    }
  }, [(_vm.tag) ? _c('div', {
    staticClass: "padding-bottom"
  }, [_vm._v("Tag:\n    "), _c('strong', [(_vm.language === "en" && _vm.tag.description) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tag.description)
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tag.name)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.location.zoek && _vm.language === "nl") ? _c('div', {
    staticClass: "padding-bottom"
  }, [_vm._v("Zoekresultaten voor\n    "), _c('strong', [_vm._v(_vm._s(_vm.$route.params.slug))])]) : _vm._e(), _vm._v(" "), (_vm.location.zoek && _vm.language === "en") ? _c('div', {
    staticClass: "padding-bottom"
  }, [_vm._v("Search results for\n    "), _c('strong', [_vm._v(_vm._s(_vm.$route.params.slug))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtered && _vm.$route.name === "programma"),
      expression: "filtered && $route.name === \"programma\""
    }],
    staticClass: "filter-description border-bottom margin-bottom",
    attrs: {
      "id": "filter-description"
    }
  }, _vm._l((_vm.filters), function(item) {
    return _c('div', [(item.description.length > 0) ? _c('div', {
      staticClass: "category-description",
      class: "category-" + item.id
    }, [(_vm.language === "nl" || item.acf.english_name.length < 1) ? _c('div', {
      staticClass: "title"
    }, [_c('strong', [_vm._v(_vm._s(item.name))])]) : _c('div', {
      staticClass: "title"
    }, [_c('strong', [_vm._v(_vm._s(item.acf.english_name))])]), _vm._v(" "), (_vm.language === "nl" || item.acf.english_description.length < 1) ? _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.description))]) : _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.acf.english_description))])]) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "grid"
    }
  }, _vm._l((_vm.posts), function(item) {
    return _c('dsGridItem', {
      attrs: {
        "item": item,
        "language": _vm.language,
        "tags": _vm.tags,
        "location": _vm.location,
        "screen-size": _vm.screenSize
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22459d42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsGrid.vue
// module id = 213
// module chunks = 2